import React, { useState } from "react";
import { Grid } from "@culturehq/components";
import { Trans } from "app/utils";
import ErrorBoundary from "components/common/ErrorBoundary";

import { useGet } from "app/hooks";

import "../analytics/styles.scss";

import { useProfile } from "app/context";
import SocialStatus from "../analytics/SocialStatus";
import EngagementTrend from "../analytics/EngagementTrend";
import SocialStoriesDoughnutChart from "../analytics/SocialStoriesDoughnutChart";
import SocialHighestPerformingStories from "../analytics/SocialHighestPerformingStories";
import SocialMostEngagedUsers from "../analytics/SocialMostEngagedUsers";
import TagFilter from "../ExternalAnalytics/TagFilter";
import { FilterByTags } from "../ExternalAnalytics/ExternalAnalytics";
import SocialChannelFilter from "./SocialChannelFilter";
import DateRangeFilter from "../ExternalAnalytics/DateRangeFilter";

const SocialAnalytics = () => {
  const get = useGet("/analytics/social/stats");

  const { profile } = useProfile();
  const [filter, setFilter] = useState("all");
  const [params, setParams] = useState({});
  const [selectedTags, setSelectedTags] = useState([]);

  const socialMediaNames = profile.organization.socialMediaTypes
    .map(socialMediaType => socialMediaType.name);

  // eslint-disable-next-line consistent-return
  const handleFilterChange = (param, value, { selectedTags = [] } = {}) => {
    if (param !== "tags") return setParams(prev => ({ ...prev, [param]: value }));

    setSelectedTags(selectedTags);
    setParams(prev => ({
      startDate: prev.startDate,
      endDate: prev.endDate,
      ...value
    }));
  };

  return (
    <div className="analytics clearfix">
      <ErrorBoundary>
        <div className="tile_main">
          <h3>
            <Trans>SOCIAL ANALYTICS</Trans>
          </h3>
          <div className="filters">
            <DateRangeFilter onChange={handleFilterChange} />
            <div className="card_title">
              <SocialChannelFilter
                filter={filter}
                setFilter={value => {
                  setFilter(value);
                  handleFilterChange("type", value === "all" ? undefined : value);
                }}
                socialMediaNames={socialMediaNames}
              />
            </div>
            <div>
              <TagFilter onChange={handleFilterChange} />
            </div>
          </div>
        </div>
        {!!selectedTags.length && (
          <FilterByTags selectedTags={selectedTags} />
        )}
        <SocialStatus get={get} params={params} />
        <EngagementTrend params={params} />
        <Grid>
          <Grid.Item md={6} lg={8} className="table_wrap">
            <SocialHighestPerformingStories params={params} />
          </Grid.Item>
          <Grid.Item md={6} lg={4}>
            <SocialStoriesDoughnutChart />
          </Grid.Item>
        </Grid>
        <SocialMostEngagedUsers params={params} />
      </ErrorBoundary>
    </div>
  );
};

export default SocialAnalytics;
